const rankings = [
  { rank: 1, title: '我独自升级', category: '韩漫·战斗', tag: '热', change: 'up' },
  { rank: 2, title: '咒术回战', category: '日漫·热血', tag: '新', change: 'up' },
  { rank: 3, title: '反派角色只有死亡结局', category: '韩漫·奇幻', tag: '热', change: 'same' },
  { rank: 4, title: '蓝色监狱', category: '日漫·体育', tag: '新', change: 'up' },
  { rank: 5, title: '某天成为公主', category: '韩漫·恋爱', tag: '热', change: 'down' },
  { rank: 6, title: '排球少年!!', category: '日漫·运动', tag: '', change: 'same' },
  { rank: 7, title: '镇魂街', category: '国漫·热血', tag: '新', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">人气排行</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">本周最受读者欢迎的热门漫画作品排行，实时追踪人气变化</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-50 transition-colors cursor-pointer`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</span>
                  {item.tag && (
                    <span className={`inline-block px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap ${
                      item.tag === '热' ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>

              <div className="flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-lg"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-lg"></i>}
                {item.change === 'same' && <span className="text-foreground-400 text-xs">–</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}